module.exports = __webpack_public_path__ + "img/fa7f0a1.png";